import React from "react";
import ApplicationImg from "../assets/img/applicationImg.png";

const Application = () => {
  return (
    <div className="container mx-auto">
       <div className="sm:block bg-white h-[126px]"></div>
      <div className="flex flex-wrap justify-between p-4 md:p-0">
        <div>
          <img src={ApplicationImg} alt="application" />
        </div>
        <div className="w-full md:w-1/2 mt-6 md:mt-14">
          <h3 className="text-4xl text-primary">Let’s get started</h3>
          <p className="opacity-60 mt-2">
            Join our students in the top most sought after universities in{" "}
          </p>

          <div className="py-10">
            
        <iframe
        src="https://forms.zohopublic.com/humanresources365global1/form/Applications/formperma/kl8sEzRp6HVm1xnFGg22obeGFn5TfzctvVW2hPWqsrE"
        width="100%"
        height="700"
        frameBorder="0"
        style={{ border: "none" }}
        allowFullScreen
        title="Zoho Form"
        className="rounded-3xl"
      ></iframe>
        </div>


          {/* <form className="my-16">
            <div className="flex justify-between gap-2">
              <div className="w-full">
                <label className="text-sm">First Name*</label>
                <input
                  type="text"
                  placeholder="First Name"
                  id="firstname"
                  className="border w-full md:w-[310px] py-3 ps-3 mt-2 border-gray-neutral rounded-lg"
                />
              </div>
              <div>
                <label className="text-sm">Last Name*</label>
                <input
                  type="text"
                  placeholder="Last Name"
                  id="lastname"
                  className="border w-full md:w-[310px] py-3 ps-3 mt-2 border-gray-neutral rounded-lg"
                />
              </div>
            </div>
            <div className="mt-4">
              <label className="text-sm">Phone Number*</label>
              <input
                type="number"
                placeholder="Phone number"
                id="phoneNumber"
                className="border w-full py-3 ps-3 mt-2 border-gray-neutral rounded-lg"
              />
            </div>
            <div className="mt-4">
              <label className="text-sm">Email*</label>
              <input
                type="email"
                placeholder="Email"
                id="phoneNumber"
                className="border w-full py-3 ps-3 mt-2 border-gray-neutral rounded-lg"
              />
            </div>
            <div className="mt-4 flex justify-between gap-4">
              <div className="w-full">
                <label className="text-sm">Course of study*</label>
                <select className="border w-full md:w-[310px] py-3 ps-3 mt-2 border-gray-neutral rounded-lg">
                    <option>-Select-</option>
                    <option>Undergraduate</option>
                    <option>Postgraduate</option>
                    <option>Masters</option>
                </select>
              </div>
              <div>
                <label className="text-sm">Study Destination*</label>
                <select className="border w-full md:w-[310px] py-3 ps-3 mt-2 border-gray-neutral rounded-lg">
                    <option>-Select-</option>
                    <option>Undergraduate</option>
                    <option>Postgraduate</option>
                    <option>Masters</option>
                </select>
              </div>
            </div>
            <div className="mt-4 flex justify-between gap-2">
              <div className="w-full">
                <label className="text-sm">Current qualification*</label>
                <select className="border w-full md:w-[310px] py-3 ps-3 mt-2 border-gray-neutral rounded-lg">
                    <option>-Select-</option>
                    <option>Undergraduate</option>
                    <option>Postgraduate</option>
                    <option>Masters</option>
                </select>
              </div>
              <div>
                <label className="text-sm">Programme in view*</label>
                <select className="border w-full md:w-[310px] py-3 ps-3 mt-2 border-gray-neutral rounded-lg">
                    <option>-Select-</option>
                    <option>Undergraduate</option>
                    <option>Postgraduate</option>
                    <option>Masters</option>
                </select>
              </div>
            </div>
            <div className="mt-4 flex justify-between gap-2">
              <div className="w-full">
                <label className="text-sm">Month of Study*</label>
                <select className="border w-full md:w-[310px] py-3 ps-3 mt-2 border-gray-neutral rounded-lg">
                    <option>-Select-</option>
                    <option>Undergraduate</option>
                    <option>Postgraduate</option>
                    <option>Masters</option>
                </select>
              </div>
              <div>
                <label className="text-sm">Year of Study**</label>
                <select className="border w-full md:w-[310px] py-3 ps-3 mt-2 border-gray-neutral rounded-lg">
                    <option>-Select-</option>
                    <option>Undergraduate</option>
                    <option>Postgraduate</option>
                    <option>Masters</option>
                </select>
              </div>
            </div>
            <div className="mt-4 flex justify-between gap-2">
              <div className="w-full">
                <label className="text-sm">Who is funding your Study?*</label>
                <select className="border w-full md:w-[310px] py-3 ps-3 mt-2 border-gray-neutral rounded-lg">
                    <option>-Select-</option>
                    <option>Undergraduate</option>
                    <option>Postgraduate</option>
                    <option>Masters</option>
                </select>
              </div>
              <div>
                <label className="text-sm">study budget*</label>
                <input
                type="text"
                placeholder="Budget"
                id="budget"
                className="border w-full md:w-[310px] py-3 ps-3 mt-2 border-gray-neutral rounded-lg"
              />
              </div>
            </div>
            <button
              
              className="uppercase text-white bg-primary mt-8 py-3 px-8 rounded-full hover:bg-gray-cool duration-300"
            >
              Submit
            </button>
          </form> */}
        </div>
      </div>
   
    </div>
  );
};

export default Application;
